<div class="add-data-container">
  <div class="dialog-header">
    <h2 class="form-title">Add Data</h2>
    <div *ngIf="selectedSession || patientSession" class="session-info">
      <span>
        <ng-container *ngIf="(selectedSession)?.ServiceID">
          {{ selectedSessionLabel(patientSession) }}
        </ng-container>
      </span>
    </div>
  </div>

  <!-- Tab View for Target vs Behavior -->
  <div class="custom-tabview">
    <div class="custom-tab-nav">
      <div 
        class="custom-tab-link" 
        [class.active]="activeTabIndex === 0"
        (click)="setActiveTab(0)"
      >
        Target Data
      </div>
      <div 
        class="custom-tab-link" 
        [class.active]="activeTabIndex === 1"
        (click)="setActiveTab(1)"
      >
        Behavior Data
      </div>
    </div>
    
    <div class="custom-tab-panels">
      <!-- Target Data Tab -->
      <div class="custom-tab-panel" [class.active]="activeTabIndex === 0">
        <form
          [formGroup]="addTargetForm"
          (ngSubmit)="onSubmitTarget()"
          [class.disabled]="isLoading()"
          id="addTargetForm"
        >
          <div class="control-row" *ngIf="!hideSessionSelector && !creatingSession()">
            <div class="control no-margin">
              <label for="target">Session:</label>
              <p-dropdown
                id="sessionDropdown"
                filter="true"
                autoWidth="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [options]="sessions()"
                [(ngModel)]="selectedSession"
                [ngModelOptions]="{standalone: true}"
                optionLabel="label"
                [loading]="isLoading()"
                (onChange)="changedSession($event)"
              >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span class="dropdown-middle-ellipsis">
                  {{ truncateMiddle(selectedOption?.label, 65) }}
                </span>
              </ng-template>
              <ng-template pTemplate="item" let-option>
                <span class="dropdown-middle-ellipsis">
                  {{ truncateMiddle(option?.label, 85) }}
                </span>
              </ng-template>
              <ng-template pTemplate="selectedSession" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>
                    <small> {{ (selectedOption.value.ServiceID ? (' (Service: #' + selectedOption.value.ServiceID + ' - ' + (selectedOption.value.StaffNames ?? []).join(', ') + ')') : '') }}</small><br>
                    {{ this.formattedDates(selectedOption.value.StartedDate, selectedOption.value.FinishedDate) }}
                   
                  </div>
                </div>
              </ng-template>
              </p-dropdown>
              <small>If the session was still not created, you can create it by clicking <a href="javascript:void(0)" (click)="showCreateSession()">here</a>.</small>
            </div>
          </div>

          <div class="control-row" *ngIf="creatingSession()">
            <div class="control no-margin">
              <label for="target">Create New Session:</label>
              <div>
                <div >
                  <label for="startDate">New Session Start Date</label>
                  <input 
                    id="startDate"
                    type="datetime-local" 
                    pInputText 
                    [(ngModel)]="newSessionStartDate" 
                    [ngModelOptions]="{standalone: true}"
                  />
                </div>
                <div >
                  <label for="endDate">New Session End Date</label>
                  <input 
                    id="endDate"
                    type="datetime-local" 
                    pInputText 
                    [(ngModel)]="newSessionEndDate" 
                    [ngModelOptions]="{standalone: true}"
                  />
                </div>
              </div>
              <small><a href="javascript:void(0)" (click)="hideCreateSession()">Back to select session</a></small>
            </div>
          </div>

          <div class="control-row" *ngIf="!hideTargetSelector">
            <div class="control no-margin">
              <label for="target">Target:</label>
              <p-dropdown
                id="targetDropdown"
                filter="true"
                autoWidth="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [options]="targets()"
                formControlName="target"
                optionLabel="label"
                [loading]="isLoading()"
                (onChange)="changedTarget($event)"
              >
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <span class="dropdown-middle-ellipsis">
                    {{ truncateMiddle(selectedOption?.label, 65) }}
                  </span>
                </ng-template>
                <ng-template pTemplate="item" let-option>
                  <span class="dropdown-middle-ellipsis">
                    {{ truncateMiddle(option?.label, 85) }}
                  </span>
                </ng-template>
              </p-dropdown>
              @if(addTargetForm.controls.target.invalid &&
              addTargetForm.controls.target.touched) {
              <span class="control-error">Target is required.</span>
              }
            </div>
          </div>

          <div class="control-row" *ngIf="shouldShowTargetStaffSelector()">
            <div class="control no-margin">
              <label for="selectedStaff">Staff:</label>
              <p-dropdown
                id="selectedStaffDropdown"
                filter="true"
                autoWidth="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [options]="targetStaffOptions()"
                formControlName="selectedStaff"
                optionLabel="label"
                [loading]="isLoading()"
              >
              </p-dropdown>
            </div>
          </div>

          <div class="control-row">
            <div class="control no-margin">
              <label for="recordedDate">
                {{ targetIsFrequency() ? 'Start Date/Time' : 'Recorded Date' }}
              </label>
              <input
                type="datetime-local"
                [style]="{ width: '100%' }"
                appendTo="body"
                class="form-control"
                name="recordedDate"
                formControlName="recordedDate"
                autocomplete="off"
              />
            </div>
          </div>

          @if (targetIsFrequency()) {
            <div class="control-row">
              <div class="control no-margin">
                <label for="targetFrequencyOccurrences">Occurrences:</label>
                <p-inputNumber
                  inputId="targetFrequencyOccurrences"
                  formControlName="frequencyOccurrences"
                  [showButtons]="true"
                  [min]="1"
                  [max]="maxBulkFrequencyOccurrences"
                  [step]="1"
                  [maxFractionDigits]="0"
                  [style]="{ width: '100%' }"
                />
                @if (addTargetForm.controls.frequencyOccurrences.invalid &&
                  addTargetForm.controls.frequencyOccurrences.touched) {
                  <span class="control-error">
                    Occurrences must be a whole number from 1 to {{ maxBulkFrequencyOccurrences }}.
                  </span>
                }
              </div>
            </div>

            @if (showTargetFrequencyEndDate()) {
              <div class="control-row">
                <div class="control no-margin">
                  <label for="targetFrequencyEndDate">End Date/Time:</label>
                  <input
                    id="targetFrequencyEndDate"
                    type="datetime-local"
                    [style]="{ width: '100%' }"
                    class="form-control"
                    formControlName="frequencyEndDate"
                    autocomplete="off"
                  />
                  @if (addTargetForm.controls.frequencyEndDate.invalid &&
                    addTargetForm.controls.frequencyEndDate.touched) {
                    <span class="control-error">
                      End date/time is required when adding more than one occurrence.
                    </span>
                  }
                </div>
              </div>
            }
          }

          @if(selectedTarget() && !targetIsFrequency()) {
          <div class="control-row">
            <div class="control no-margin">
                @if (targetIsDuration() || targetIsToileting()) {
                    <label for="duration">Duration (in minutes): </label>
                } @else {
                    <label for="value">Value:</label>
                }
              @if (targetIsPromptBased()) {
                    @if (targetIsEchoic()) {
                        <p-dropdown
                            class="pe-1"
                            [options]="promptOptionsForTarget()"
                            formControlName="selectedPromptCode"
                            [checkmark]="true"
                            optionLabel="text"
                            optionValue="value"
                            [style]="{ width: '100%' }"
                            [appendTo]="'body'"
                            placeholder="Select a prompt code"
                        />
                        <p-dropdown
                        [options]="extraOptionsForEchoicTarget()"
                        formControlName="selectedEchoicRate"
                        [checkmark]="true"
                        optionLabel="text"
                        optionValue="value"
                        [style]="{ width: '100%' }"
                        [appendTo]="'body'"
                        placeholder="Select an echoic rate"
                        />
                    } @else {
                    <p-dropdown
                    [options]="promptOptionsForTarget()"
                    formControlName="selectedPromptCode"
                    [checkmark]="true"
                    optionLabel="text"
                    optionValue="value"
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                    />
                    } 
                } @else if (targetIsIntValueOnly()) {
                    <input
                    pInputText
                    type="number"
                    formControlName="textValue"
                    [style]="{ width: '100%' }"
                    placeholder="Enter a value"
                    />
                } @else if (targetIsDuration() || targetIsToileting()) {
                    <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    formControlName="duration"
                    [showButtons]="true"
                    [minFractionDigits]="1"
                    [maxFractionDigits]="2"
                    />
                } @else if (targetIsWholePartialInterval()) {
                    <span><p-checkbox inputId="happened-adddata" [binary]="true" formControlName="happened" [style]="{ color: 'black' }" /></span>
                    <label for="happened-adddata">Happened</label>
                } @else if (targetIsFluencyRate()) {
                  <div class="flex flex-column gap-2">
                    <label for="duration">Duration (in minutes):</label>
                    <p-inputNumber
                        autoWidth="false"
                        [style]="{ width: '100%' }"
                        formControlName="duration"
                        [showButtons]="true"
                        [min]="0.016667"
                        [minFractionDigits]="1"
                        [maxFractionDigits]="2"
                    />
                    <label for="correctCount">Correct Count:</label>
                      <p-inputNumber
                          formControlName="correctCount"
                          [showButtons]="true" 
                          [min]="0"
                          placeholder="Correct Count"
                      />
                    <label for="incorrectCount">Incorrect Count:</label>
                        <p-inputNumber
                            formControlName="incorrectCount" 
                            [showButtons]="true"
                            [min]="0"
                            placeholder="Incorrect Count"
                        />
                  </div>
                }@else {
                    <input
                    pInputText
                    type="text"
                    formControlName="textValue"
                    [style]="{ width: '100%' }"
                    placeholder="Enter a value"
                    />
                }
            </div>
          </div>
          }

          @if (targetIsToileting()) {
            <div class="control-row">
              <div class="control no-margin">
                <label for="toileting">Toileting:</label>
              <div class="toileting-checkboxes" style="display: flex; justify-content: space-between; gap: 1rem;">
                <span>
                  <p-checkbox
                    inputId="add-data-toileting-urination-on"
                    [binary]="true"
                    [ngModel]="urinationOn()"
                    (ngModelChange)="urinationOn.set($event)"
                    [ngModelOptions]="{standalone: true}"
                    styleClass="app-checkbox">
                  </p-checkbox>
                  <label for="add-data-toileting-urination-on" class="ml-2">Urination On</label>
                </span>

                <span>
                  <p-checkbox
                    inputId="add-data-toileting-urination-off"
                    [binary]="true"
                    [ngModel]="urinationOff()"
                    (ngModelChange)="urinationOff.set($event)"
                    [ngModelOptions]="{standalone: true}"
                    styleClass="app-checkbox">
                  </p-checkbox>
                  <label for="add-data-toileting-urination-off" class="ml-2">Urination Off</label>
                </span>

                <span>
                  <p-checkbox
                    inputId="add-data-toileting-bowel-on"
                    [binary]="true"
                    [ngModel]="bowelMovementOn()"
                    (ngModelChange)="bowelMovementOn.set($event)"
                    [ngModelOptions]="{standalone: true}"
                    styleClass="app-checkbox">
                  </p-checkbox>
                  <label for="add-data-toileting-bowel-on" class="ml-2">Bowel Movement On</label>
                </span>

                <span>
                  <p-checkbox
                    inputId="add-data-toileting-bowel-off"
                    [binary]="true"
                    [ngModel]="bowelMovementOff()"
                    (ngModelChange)="bowelMovementOff.set($event)"
                    [ngModelOptions]="{standalone: true}"
                    styleClass="app-checkbox">
                  </p-checkbox>
                  <label for="add-data-toileting-bowel-off" class="ml-2">Bowel Movement Off</label>
                </span>

                <span>
                  <p-checkbox
                    inputId="add-data-toileting-no-void"
                    [binary]="true"
                    [ngModel]="noVoid()"
                    (ngModelChange)="noVoid.set($event)"
                    [ngModelOptions]="{standalone: true}"
                    styleClass="app-checkbox">
                  </p-checkbox>
                  <label for="add-data-toileting-no-void" class="ml-2">No Void</label>
                </span>
              </div>
              </div>
            </div>
          }

          <p class="actions" style="position: sticky; bottom: 0" id="addTargetButtons">
            <button
              type="button"
              class="switch-mode-button"
              style="margin-right: auto; cursor: pointer;"
              (click)="onCancel()"
              [disabled]="isLoading()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="side-menu-button2"
              style="cursor: pointer;"
              [disabled]="isLoading()"
              (click)="onSaveAndAddMoreTarget()"
            >
              Save and Add More
            </button>
            <button
              type="submit"
              id="saveTargetButton"
              class="side-menu-button2"
              style="cursor: pointer;"
              [disabled]="isLoading()"
            >
              Add Target Data
            </button>
          </p>
        </form>
      </div>

      <!-- Behavior Data Tab -->
      <div class="custom-tab-panel" [class.active]="activeTabIndex === 1">
        <form
          [formGroup]="addBehaviorForm"
          (ngSubmit)="onSubmitBehavior()"
          [class.disabled]="isLoading()"
          id="addBehaviorForm"
        >
          <div class="control-row" *ngIf="!hideSessionSelector && !creatingSession()">
            <div class="control no-margin">
              <label for="behavior">Session:</label>
              <p-dropdown
                id="sessionDropdown"
                filter="true"
                autoWidth="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [options]="sessions()"
                [(ngModel)]="selectedSession"
                [ngModelOptions]="{standalone: true}"
                optionLabel="label"
                optionValue="value"
                [loading]="isLoading()"
                (onChange)="changedSession($event)"
              >
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <span class="dropdown-middle-ellipsis">
                  {{ truncateMiddle(selectedOption?.label, 65) }}
                </span>
              </ng-template>
              <ng-template pTemplate="item" let-option>
                <span class="dropdown-middle-ellipsis">
                  {{ truncateMiddle(option?.label, 85) }}
                </span>
              </ng-template>
              <ng-template pTemplate="selectedSession" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>
                    <small> {{ (selectedOption.value.ServiceID ? (' (Service: #' + selectedOption.value.ServiceID + ' - ' + (selectedOption.value.StaffNames ?? []).join(', ') + ')') : '') }}</small><br>
                    {{ this.formattedDates(selectedOption.value.StartedDate, selectedOption.value.FinishedDate) }}
                   
                  </div>
                </div>
              </ng-template>
              </p-dropdown>
              <small>If the session was still not created, you can create it by clicking <a href="javascript:void(0)" (click)="showCreateSession()">here</a>.</small>
            </div>
          </div>

          <div class="control-row" *ngIf="creatingSession()">
            <div class="control no-margin">
              <label for="behavior">Create New Session:</label>
              <div>
                <div >
                  <label for="startDate">New Session Start Date</label>
                  <input 
                    id="startDate"
                    type="datetime-local" 
                    pInputText 
                    [(ngModel)]="newSessionStartDate" 
                    [ngModelOptions]="{standalone: true}"
                  />
                </div>
                <div >
                  <label for="endDate">New Session End Date</label>
                  <input 
                    id="endDate"
                    type="datetime-local" 
                    pInputText 
                    [(ngModel)]="newSessionEndDate" 
                    [ngModelOptions]="{standalone: true}"
                  />
                </div>
              </div>
              <small><a href="javascript:void(0)" (click)="hideCreateSession()">Back to select session</a></small>
            </div>
          </div>

          @if (!hideBehaviorSelector) { 
            <div class="control-row">
              <div class="control no-margin">
                <label for="behavior">Behavior:</label>
                <p-dropdown
                  id="behaviorDropdown"
                  filter="true"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="behaviors()"
                  formControlName="behavior"
                  optionLabel="label"
                  [loading]="isLoading()"
                  (onChange)="changedBehavior($event)"
                >
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    <span class="dropdown-middle-ellipsis">
                      {{ truncateMiddle(selectedOption?.label, 65) }}
                    </span>
                  </ng-template>
                  <ng-template pTemplate="item" let-option>
                    <span class="dropdown-middle-ellipsis">
                      {{ truncateMiddle(option?.label, 85) }}
                    </span>
                  </ng-template>
                </p-dropdown>
                @if(addBehaviorForm.controls.behavior.invalid &&
                addBehaviorForm.controls.behavior.touched) {
                <span class="control-error">Behavior is required.</span>
                }
              </div>
            </div>
          }

          <div class="control-row" *ngIf="shouldShowBehaviorStaffSelector()">
            <div class="control no-margin">
              <label for="selectedStaffBehavior">Staff:</label>
              <p-dropdown
                id="selectedStaffBehaviorDropdown"
                filter="true"
                autoWidth="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [options]="behaviorStaffOptions()"
                formControlName="selectedStaff"
                optionLabel="label"
                [loading]="isLoading()"
              >
              </p-dropdown>
            </div>
          </div>

          <div class="control-row">
            <div class="control no-margin">
              <label for="recordedDate">
                {{ behaviorIsFrequency() ? 'Start Date/Time' : 'Recorded Date' }}
              </label>
              <input
                type="datetime-local"
                [style]="{ width: '100%' }"
                appendTo="body"
                class="form-control"
                name="recordedDate"
                formControlName="recordedDate"
                autocomplete="off"
              />
            </div>
          </div>

          @if (behaviorIsFrequency()) {
            <div class="control-row">
              <div class="control no-margin">
                <label for="frequencyOccurrences">Occurrences:</label>
                <p-inputNumber
                  inputId="frequencyOccurrences"
                  formControlName="frequencyOccurrences"
                  [showButtons]="true"
                  [min]="1"
                  [max]="maxBulkFrequencyOccurrences"
                  [step]="1"
                  [maxFractionDigits]="0"
                  [style]="{ width: '100%' }"
                />
                @if (addBehaviorForm.controls.frequencyOccurrences.invalid &&
                  addBehaviorForm.controls.frequencyOccurrences.touched) {
                  <span class="control-error">
                    Occurrences must be a whole number from 1 to {{ maxBulkFrequencyOccurrences }}.
                  </span>
                }
              </div>
            </div>

            @if (showFrequencyEndDate()) {
              <div class="control-row">
                <div class="control no-margin">
                  <label for="frequencyEndDate">End Date/Time:</label>
                  <input
                    id="frequencyEndDate"
                    type="datetime-local"
                    [style]="{ width: '100%' }"
                    class="form-control"
                    formControlName="frequencyEndDate"
                    autocomplete="off"
                  />
                  @if (addBehaviorForm.controls.frequencyEndDate.invalid &&
                    addBehaviorForm.controls.frequencyEndDate.touched) {
                    <span class="control-error">
                      End date/time is required when adding more than one occurrence.
                    </span>
                  }
                </div>
              </div>
            }
          }

          @if(selectedBehavior() && !behaviorIsFrequency()) {
            <div class="control-row">
              <div class="control no-margin">
                  @if (behaviorIsDuration()) {
                      <label for="duration">Duration (in minutes): </label>
                  } @else if (behaviorIsInterval()) {
                      <label for="happenedDuringInterval">Happened during interval:</label>
                  } @else {
                      <label for="value">Value:</label>
                  } 
                  @if (behaviorIsDuration()) {
                      <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      formControlName="duration"
                      [showButtons]="true"
                      [minFractionDigits]="1"
                      [maxFractionDigits]="2"
                      />
                  } @else if (behaviorIsInterval()) {
                      <p-checkbox
                        formControlName="happenedDuringInterval"
                        [style]="{ width: '100%' }"
                      />
                  } @else {
                      <input
                      pInputText
                      type="text"
                      formControlName="textValue"
                      [style]="{ width: '100%' }"
                      placeholder="Enter a value"
                      />
                  }
              </div>
            </div>
          }

          <!-- Antecedent picker with other option-->
          <div class="control-row">
            <div class="control no-margin">
              <label for="antecedent">Antecedent:</label>
              <p-multiSelect
                id="antecedentDropdown"
                filter="true"
                autoWidth="false"
                [style]="{ width: '100%' }"
                appendTo="body"
                [options]="antecedents()"
                formControlName="selectedAntecedent"
                optionLabel="PatientBehaviorAntecedent"
                [loading]="isLoading()"
                (onChange)="selectedAntecedents.set($event.value)"
              >
              </p-multiSelect>
            </div>
          </div>

          <!-- Consequence picker with other option-->
          <div class="control-row">
            <div class="control no-margin">
                <label for="consequence">Consequence:</label>
                <p-multiSelect
                  id="consequenceDropdown"
                  filter="true"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="consequences()"
                  formControlName="selectedConsequence"
                  optionLabel="PatientBehaviorConsequence"
                  [loading]="isLoading()"
                  (onChange)="selectedConsequences.set($event.value)"
                />
            </div>
          </div>

          <!-- Severity picker-->
          <div class="control-row">
            <div class="control no-margin">
                <label for="severity">Severity:</label>
                <p-dropdown
                  id="severityDropdown"
                  filter="true"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="severities()"
                  formControlName="selectedSeverity"
                  optionLabel="PatientBehaviorSeverity"
                  [loading]="isLoading()"
                  (onChange)="selectedSeverity.set($event.value)"
                />
            </div>
          </div>

          <!-- Response picker-->
          <div class="control-row">
            <div class="control no-margin">
                <label for="response">Response:</label>
                <p-dropdown
                  id="responseDropdown"
                  filter="true"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="responses()"
                  formControlName="selectedResponse"
                  optionLabel="PatientBehaviorResponse"
                  [loading]="isLoading()"
                  (onChange)="selectedResponse.set($event.value)"
                />
            </div>
          </div>

          <!-- Location picker-->
          <div class="control-row">
            <div class="control no-margin">
                <label for="location">Location:</label>
                <p-dropdown
                  id="locationDropdown"
                  filter="true"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  appendTo="body"
                  [options]="locations()"
                  formControlName="selectedLocation"
                  optionLabel="PatientBehaviorLocation"
                  [loading]="isLoading()"
                  (onChange)="selectedLocation.set($event.value)"
                />
            </div>
          </div>

          <!-- Notes field-->
          <div class="control-row">
            <div class="control no-margin">
                <label for="notes">Notes:</label>
                <textarea
                  pTextarea
                  formControlName="notes"
                  [style]="{ width: '100%' }"
                  [rows]="3"
                  placeholder="Enter any additional notes"
                ></textarea>
            </div>
          </div>

          <p class="actions" style="position: sticky; bottom: 0" id="addBehaviorButtons">
            <button
              type="button"
              class="switch-mode-button"
              style="margin-right: auto; cursor: pointer;"
              (click)="onCancel()"
              [disabled]="isLoading()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="side-menu-button2"
              style="cursor: pointer;"
              [disabled]="isLoading()"
              (click)="onSaveAndAddMoreBehavior()"
            >
              Save and Add More
            </button>
            <button
              type="submit"
              id="saveBehaviorButton"
              class="side-menu-button2"
              style="cursor: pointer;"
              [disabled]="isLoading()"
            >
              Add Behavior Data
            </button>
          </p>
        </form>
      </div>
    </div>
  </div>

  @if (isLoading()) {
  <div class="loading">
    <app-loading-indicator />
  </div>
  }
</div>
